module.exports = __webpack_public_path__ + "media/images/icons/soon-46d0cfd6d308a6120375413fdccc127b.png";